import {
  ped_main_steps,
  ped_sub_steps,
  step_status,
} from "helpers/enum";

export const pedVisitFlowInitialState = {
  currentScreen: ped_sub_steps.select_patient,
  incompleteData: null,
  patientsList: null,
  completedProgress: 0,
  paymentMethod: null,
  mainSteps: {
    [ped_main_steps.visit_details]: {
      status: step_status.current,
      currentScreen: null,
    },
    [ped_main_steps.main_select_slot]: {
      status: step_status.upcoming,
    },
    [ped_main_steps.basic_info]: {
      status: step_status.upcoming,
    },
    [ped_main_steps.additional_details]: {
      status: step_status.upcoming,
    },
  },
  subSteps: {
    [ped_sub_steps.select_patient]: {
      value: null,
      isValid: false,
      prevScreen: null,
      nextScreen: null,
      status: step_status.current,
      headerTitle: "Visit Details",
      progress: 10,
    },
    [ped_sub_steps.select_child]: {
      value: null,
      isValid: false,
      prevScreen: ped_sub_steps.select_patient,
      nextScreen: ped_sub_steps.select_condition,
      headerTitle: "Visit Details",
    },
    [ped_sub_steps.select_someone_else]: {
      value: null,
      isValid: false,
      prevScreen: ped_sub_steps.select_patient,
      nextScreen: ped_sub_steps.select_condition,
      headerTitle: "Visit Details",
    },
    [ped_sub_steps.select_condition]: {
      value: null,
      isValid: false,
      prevScreen: ped_sub_steps.select_patient,
      nextScreen: ped_sub_steps.select_slot,
      status: step_status.upcoming,
      headerTitle: "Visit Details",
      progress: 20,
    },
    [ped_sub_steps.select_slot]: {
      value: null,
      isValid: false,
      prevScreen: ped_sub_steps.select_condition,
      nextScreen: ped_sub_steps.confirm_residence,
      headerTitle: "Select Your Appointment Date and Time",
      status: step_status.upcoming,
      progress: 30,
    },
    [ped_sub_steps.confirm_residence]: {
      value: null,
      isValid: false,
      prevScreen: ped_sub_steps.select_slot,
      nextScreen: ped_sub_steps.identity_confirmation,
      status: step_status.upcoming,
      headerTitle: "Basic Info",
      progress: 40,
      rightButtonText: "Confirm",
    },
    [ped_sub_steps.identity_confirmation]: {
      value: null,
      isValid: false,
      prevScreen: ped_sub_steps.confirm_residence,
      nextScreen: ped_sub_steps.select_pharmacy,
      status: step_status.upcoming,
      headerTitle: "Confirm your identity",
      progress: 50,
    },
    [ped_sub_steps.select_pharmacy]: {
      value: null,
      isValid: false,
      status: step_status.upcoming,
      prevScreen: ped_sub_steps.identity_confirmation,
      nextScreen: ped_sub_steps.symptoms,
      headerTitle: "Select Pharmacy",
      progress: 80,
    },
    [ped_sub_steps.symptoms]: {
      value: null,
      isValid: false,
      status: step_status.upcoming,
      prevScreen: ped_sub_steps.select_pharmacy,
      nextScreen: ped_sub_steps.additional_info,
      headerTitle: "Select Symptoms",
      progress: 90,
    },
    [ped_sub_steps.additional_info]: {
      value: null,
      isValid: false,
      prevScreen: ped_sub_steps.symptoms,
      nextScreen: null,
      status: step_status.upcoming,
      headerTitle: "Additional Information",
      progress: 100,
    },
  },
};
